import axios from 'axios';
import { getApiBaseUrl } from '../lib/api-base-url';

const API_URL = getApiBaseUrl();

/** Mirrors be/src/timesheet-reminders/timesheet-reminders.service.ts */
export type ReminderTimesheetStatus = 'none' | 'draft' | 'submitted' | 'approved';

export interface ReminderRecipient {
  userId: number;
  name: string;
  email: string;
  role: string;
  relationshipType: string;
  timesheetStatus: ReminderTimesheetStatus;
  entryCount: number;
  /** Live link for this month, if the person has one in the inbox */
  link: { sentAt: string; expiresAt: string; useCount: number; lastUsedAt: string | null } | null;
}

export interface ReminderCampaign {
  id: number;
  sentAt: string;
  recipientCount: number;
  sentCount: number;
  createdBy: { id: number; name: string } | null;
}

export interface ReminderStatus {
  period: { year: number; month: number };
  /** When a link sent now would stop working */
  expiresAt: string;
  emailEnabled: boolean;
  /** Newest first */
  campaigns: ReminderCampaign[];
  /** Every active user of the tenant, by name */
  recipients: ReminderRecipient[];
}

export interface SendRemindersResult {
  campaignId: number;
  sent: number[];
  failed: { userId: number; reason: string }[];
}

export const timesheetReminderService = {
  getStatus: async (year: number, month: number): Promise<ReminderStatus> => {
    const response = await axios.get(`${API_URL}/timesheet-reminders/status`, { params: { year, month } });
    return response.data;
  },

  send: async (year: number, month: number, userIds: number[]): Promise<SendRemindersResult> => {
    const response = await axios.post(`${API_URL}/timesheet-reminders/send`, { year, month, userIds });
    return response.data;
  },
};
